import React, { useRef } from "react";
import styles from "../Race/Race.module.css";
import FontPicker from "../FontPicker/FontPicker";
import SavePresetModal from "../Modals/SavePresetModal/SavePresetModal";
import { saveTheme } from "../../restAPI";

const CustomizeBlock = ({ def, onChange, getThemeData, option = {}, className, ...props }) => {
  const savePresetModalRef = useRef();

  return (
    <div className={styles.customizeBlock + " " + className}>
      <div className={styles.colorsBlock}>
        {/* Main color */}
        <div className={styles.customizeItem}>
          <input type={"color"} onChange={(e) => onChange("mainColor", e.target.value)} defaultValue={def.mainColor} />
          <label className={styles.customizeItemLabel}>Main color</label>
        </div>
        {/* Header color */}
        <div className={styles.customizeItem}>
          <input
            type={"color"}
            onChange={(e) => onChange("headerColor", e.target.value)}
            defaultValue={def.headerColor}
          />
          <label className={styles.customizeItemLabel}>Header color</label>
        </div>
        {/* Background color */}
        <div className={styles.customizeItem}>
          <input type={"color"} onChange={(e) => onChange("BGColor", e.target.value)} defaultValue={def.BGColor} />
          <label className={styles.customizeItemLabel}>Background color</label>
        </div>
        {/* Text color */}
        <div className={styles.customizeItem}>
          <input type={"color"} onChange={(e) => onChange("textColor", e.target.value)} defaultValue={def.textColor} />
          <label className={styles.customizeItemLabel}>Text color</label>
        </div>
      </div>
      <div className={styles.otherBlock}>
        {/* Font */}
        {(option.showFontSelector === undefined || option.showFontSelector) && (
          <div className={styles.customizeItem}>
            <FontPicker def={def.font} changeFontFamily={(e) => onChange("FontFamily", e)} />
            <label className={styles.customizeItemLabel}>Font</label>
          </div>
        )}
        {/* Logo */}
        <div className={styles.customizeItem}>
          <input placeholder={"Link"} onChange={(e) => onChange("logo", e.target.value)} />
          <label className={styles.customizeItemLabel}>Logo (link to img)</label>
        </div>
      </div>
      {/* Save */}
      <button className={"grinBtn shadow"} onClick={() => (savePresetModalRef.current.style.display = "block")}>
        Save
      </button>
      <div ref={savePresetModalRef} style={{ display: "none" }}>
        <SavePresetModal
          onSubmit={(name, isNew) => {
            const themeData = getThemeData();
            saveTheme(name, themeData, isNew);
            savePresetModalRef.current.style.display = "none";
          }}
          onCancel={() => (savePresetModalRef.current.style.display = "none")}
        />
      </div>
    </div>
  );
};

export default CustomizeBlock;
